import { useEffect, useState, RefObject } from 'react'
import { useWindowSize } from 'commons/customHooks/useWindowSize'
import { WidthMenuProps } from 'components'

export function useElementPosition(elementRef: RefObject<HTMLElement>): WidthMenuProps {
  const [windowWidth] = useWindowSize()
  const [elementPosition, setElementPosition] = useState<WidthMenuProps>(
    {} as WidthMenuProps
  )

  useEffect(() => {
    if (elementRef.current) {
      const rightEdge = elementRef.current?.getBoundingClientRect().right
      const leftEdge = elementRef.current?.getBoundingClientRect().left
      const endPosition = rightEdge - leftEdge
      setElementPosition({
        startPosition: leftEdge,
        endPosition: endPosition
      })
    }
  }, [elementRef, windowWidth])

  return elementPosition
}
